"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_business__phone__or__fixed__line__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "3b3ed504-ff67-412f-9edb-1c67b2918a2e",
    x1: 89.84,
    y1: 44.84,
    x2: 141.66,
    y2: 96.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6f6f6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "74f4597a-b5ef-4cbf-a932-005b9444d964",
    x1: 24.32,
    y1: 61.7,
    x2: 146.37,
    y2: 183.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "980b0169-0cc1-4cc3-af12-4bb434b98ced",
    "data-name": "Business_phone_ic_hi",
    viewBox: "0 0 191.5 191.5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.25,27.75h104.5a16,16,0,0,1,16,16v104a16,16,0,0,1-16,16H55.25a0,0,0,0,1,0,0v-136A0,0,0,0,1,55.25,27.75Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.76,
    y: 99.76,
    width: 70.99,
    height: 3.99,
    rx: 1.99,
    ry: 1.99,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.76,
    y: 111.76,
    width: 70.99,
    height: 3.99,
    rx: 1.99,
    ry: 1.99,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.76,
    y: 123.76,
    width: 70.99,
    height: 3.99,
    rx: 1.99,
    ry: 1.99,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "8010e1ad-adb4-404e-b4cb-5f0730865bda",
    "data-name": "Bounding Box",
    points: "0 191.5 0 0 191.5 0 191.5 191.5 0 191.5",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.75,
    y: 49.75,
    width: 72,
    height: 42,
    rx: 4,
    ry: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.75,
    y: 51.75,
    width: 68,
    height: 38,
    rx: 2,
    ry: 2,
    fill: "#333",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.75,
    y: 51.75,
    width: 68,
    height: 38,
    rx: 2,
    ry: 2,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.75,
    y: 51.75,
    width: 68,
    height: 38,
    rx: 2,
    ry: 2,
    opacity: 0.5,
    fill: "url(#3b3ed504-ff67-412f-9edb-1c67b2918a2e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.71,163.75H58.49l-.23-136L175.75,145.25l0,3.53C175.72,157,167.5,163.75,160.71,163.75Z",
    opacity: 0.2,
    fill: "url(#74f4597a-b5ef-4cbf-a932-005b9444d964)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145.75,
    cy: 144.17,
    r: 6,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.75,
    y: 23.75,
    width: 48,
    height: 144,
    rx: 16,
    ry: 16,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.75,161.75H60.23a15.92,15.92,0,0,0,3.52-10v-2a16,16,0,0,1-16,16h-16a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16h16a15.92,15.92,0,0,0,10.56-4H159.75a16,16,0,0,0,16-16v-2A16,16,0,0,1,159.75,161.75Z",
    opacity: 0.06
  }))), /*#__PURE__*/React.createElement("title", null, "business-phone-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "6a290eff-b637-41df-a2c8-259231a9882a",
    "data-name": "Fixed_line_ic"
  }, /*#__PURE__*/React.createElement("use", {
    id: "e9f7e559-76c3-4c46-b0f6-8adb21d81c37",
    "data-name": "Business_phone_ic_hi",
    width: 191.5,
    height: 191.5,
    transform: "translate(0.25 0.25)",
    xlinkHref: "#980b0169-0cc1-4cc3-af12-4bb434b98ced"
  })));
}

var _default = ic_business__phone__or__fixed__line__dark;
exports.default = _default;